import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-items-carousal',
  templateUrl: './items-carousal.component.html',
  styleUrls: ['./items-carousal.component.css'],
})
export class ItemsCarousalComponent implements OnInit {

  @Input() data:any;
  @Output() dept: EventEmitter<any> = new EventEmitter<any>();
  constructor() {
  }
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    method: {},
    speed: 300,
    focusOnSelect: false,
    swipe: true,
    centerPadding: '25px',
    infinite: true,
    responsive: [
      {
        breakpoint: 1930,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          focusOnSelect: false,
          swipe: true

        }
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          focusOnSelect: false,
          swipe: true,
        }
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          focusOnSelect: false,
          swipe: true

        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        }
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        }
      },

      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          swipe: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
        }
      }
    ],
    nextArrow: '<button class="slick-next">Next</button> ',
    prevArrow: '<button class="slick-prev">Previous</button>'
  };

  selectedItemIndex: number;

  ngOnInit() {
    this.selectedItemIndex = 0;
  }
  fetchResultsByCategory(data:any)
  {
    this.selectedItemIndex = data.id - 1;
    this.dept.emit(data);
  }

}
